import { MuxDragHandle2 } from "@/Icons";
import { Field } from "../types";
import { getTypeLabel } from "../utils";

interface FieldItemProps {
  field: Field | null;
}

export function FieldPreview({ field }: FieldItemProps) {
  return (
    <div className="field-item screenshot">
      <div className="drag-area">
        <MuxDragHandle2 />
      </div>
      <div className="field-info">
        <span className="field-name">{field?.label}</span>
        <span className="field-type">{getTypeLabel(field?.type)}</span>
      </div>
    </div>
  );
}
